import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';

@Component({
  selector: 'app-e106',
  templateUrl: './e106.component.html',
  styleUrls: ['./e106.component.scss', '../platform.component.scss'],
})

/**
 * 会員主催イベント申請登録完了 (E106)
 */
export class E106Component extends PlatformComponent {
  inputType: string = '';

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // inputType取得
    this.inputType = this.route.snapshot.queryParams['inputType'] || '';
  }

  /**
   * 会員主催イベント申請一覧（E103）または修正画面（E104）へ遷移する
   */
  public moveE103OrE104(): void {
    if (this.inputType === GENERATE_INPUT_TYPE.NEW) {
      // 新規の場合は E103 へ遷移
      this.router.navigate(['pages/platform/e103']);
    } else if (this.inputType === GENERATE_INPUT_TYPE.EDIT) {
      // 修正の場合は E104 へ遷移
      const memberEventId = this.route.snapshot.queryParams['member_event_id'];
      this.router.navigate(['pages/platform/e104'], {
        queryParams: {
          screenId: 'e104',
          member_event_id: memberEventId,
          inputType: this.inputType,
        },
      });
    } else {
      // その他の場合は E103 へ遷移
      this.router.navigate(['pages/platform/e103']);
    }
  }
}
